export const getRootUrl = async () => {
  return global.baseUrl;
};
